<template>
    <div class="background-spinner">
        <spinner class="background-spinner-spinner" :line-fg-color="'#c6e0a7'" :size="64" :line-size="12"/>
        <div class="background-spinner-clear"></div>
    </div>
</template>
<script>
import Spinner from '../../components/Spinner.vue'

export default {
    components: {
        Spinner
    }
}
</script>

<style>
.background-spinner {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.background-spinner-spinner {
    position: relative;
    top: 50%;
    z-index: 9;
}

.background-spinner-clear {
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 0.7;
}
</style>




// WEBPACK FOOTER //
// src/webpack/vue/backend/components/BackgroundSpinner.vue